import {createEnvironmentSlice} from "@/data/create_environment_slice.js";

export const {reducer, replace, update} = createEnvironmentSlice("Metric");
